import ENV from "@environments";
import axios from "axios";
import { setItem, removeItem } from "@utils";
import { ShowNotification, NotificationType } from "@utils";
import { getLocalStorageItem, getSessionStorageItem } from "@utils";

const TOKEN = "TOKENVIDEOCONFERENCIA";
const TOKENACFAZ = "TOKENACFAZ";

const paramsBasic = {
  grant_type: ENV.TOKEN.grant_type_basic,
  provision_key: ENV.TOKEN.password,
  authenticated_userid: ENV.TOKEN.username,
  client_id: ENV.TOKEN.clientId,
  client_secret: ENV.TOKEN.clientSecret,
};

const api = axios.create({
  baseURL: ENV?.BASE_URL,
  mode: "no-cors",
});

api.interceptors.request.use(
  async (request) => {
    const response = await gerarToken();

    request.headers = {
      "Content-Type": "application/json",
      ...request.headers,
      usuario_so: getLocalStorageItem("osUser"),
      mac: getLocalStorageItem("mac"),
      ip: getLocalStorageItem("IP"),
      idusuario: getLocalStorageItem("IDUSUARIO"),
      maquina: getLocalStorageItem("MAQUINA"),
      usuario: getLocalStorageItem("USUARIO"),
      Authorization: "Bearer " + response?.access_token,
    };

    return request;
  },
  (error) => {
    return Promise.reject(error);
  },
);

api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    ShowNotification(
      NotificationType.Error,
      error?.response?.data?.message || error?.message,
    );
    return Promise.reject(error);
  },
);

const gerarToken = async () => {
  const token = getToken();
  const segundosExpirar = new Date().getTime() / 1000;
  const tokenExpirou = segundosExpirar >= token?.dateExpires;
  if (!token || tokenExpirou) {
    removeToken();
    const response = await axios.post(
      `${ENV?.BASE_URL}/acfaz/login/oauth2/token`,
      paramsBasic,
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
    );

    setToken(response?.data);
    return response.data;
  }

  return token;
};

const setToken = (token) => {
  setItem(TOKEN, JSON.stringify(token));
};

const getToken = () => {
  try {
    const userType = getLocalStorageItem("USERTYPE");
    if (userType === "agr") {
      return getTokenAgr();
    } else {
      return getTokenCliente();
    }
  } catch (error) {}
};

const getTokenCliente = () => {
  return JSON.parse(getSessionStorageItem(TOKEN));
};

const getTokenAgr = () => {
  return JSON.parse(getLocalStorageItem(TOKENACFAZ));
};

const removeToken = () => {
  removeItem(TOKEN);
};

export { api };
